<script lang="ts">
  import Simulator from "./Simulator.svelte";
  import MazeEditor from "./MazeEditor.svelte";
  import { code, maze } from "./stores";
  import CodeEditor from "./CodeEditor.svelte";

  let editing = true;

  function onEdit() {
    if ($maze.isValid()) {
      editing = false;
    } else {
      alert("Maze is invalid!");
    }
  }
</script>

<main class="container mt-3">
  <div class="card mb-3">
    <h5 class="card-header">Code</h5>
    <div class="card-body">
      <CodeEditor bind:code={$code} />
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <ul class="nav nav-tabs card-header-tabs">
        <li class="nav-item">
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a
            class="nav-link"
            class:active={editing}
            on:click|preventDefault={() => (editing = true)}
            href="#"
          >
            Editor
          </a>
        </li>
        <li class="nav-item">
          <!-- svelte-ignore a11y-invalid-attribute -->
          <a
            class="nav-link"
            class:active={!editing}
            on:click|preventDefault={onEdit}
            href="#"
          >
            Simulator
          </a>
        </li>
      </ul>
    </div>
    <div class="card-body">
      {#if editing}
        <MazeEditor bind:maze={$maze} />
      {:else}
        <Simulator maze={$maze} code={$code} />
      {/if}
    </div>
  </div>
</main>

<style>
  .container {
    margin-bottom: 256px;
  }
</style>
